import React, {useState} from "react";
import {IconButton} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

function ActionMenu({ row, onView, onEdit, onDelete }) {
    const [anchorEl, setAnchorEl] = useState(null);
    return (
        <>
            <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                {
                    onView &&
                    <MenuItem onClick={() => { onView(row); setAnchorEl(null); }}>
                        <ListItemIcon><VisibilityIcon fontSize="small" /></ListItemIcon>
                        View
                    </MenuItem>
                }
                {
                    onEdit &&
                    <MenuItem onClick={() => { onEdit(row); setAnchorEl(null); }}>
                        <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
                        Edit
                    </MenuItem>
                }
                {
                    onDelete &&
                    <MenuItem onClick={() => { onDelete(row.id); setAnchorEl(null); }} sx={{ color: "error.main" }}>
                        <ListItemIcon><DeleteIcon fontSize="small" sx={{ color: "error.main" }} /></ListItemIcon>
                        Delete
                    </MenuItem>
                }
            </Menu>
        </>
    );
}

export default ActionMenu;
